import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)
import { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { toast } from 'react-toastify'
import { BOOKING_REQUEST_STATUS } from 'src/consumer/constants'
import { ProfileContext } from 'src/consumer/context/ProfileContext'
import { getBookingRequestsForMentor } from 'src/consumer/services/featureServices'
import { isCommonResponseSuccessful } from 'src/mentor/helpers/utilityFunctions'
import { isTokenInvalidOrAbsent } from './login/ProtectedRoute'

// Routes where this mentor-side polling + auto-redirect makes no sense.
// /patient-home is the patient portal — pulling a logged-in dual-role user
// (e.g. a developer who is both ROLE_TEACHER and ROLE_PATIENT) over to
// /booking-requests-for-mentors when they're trying to use their patient app
// is the wrong UX, and the underlying GET /api/secure/teacher/booking-request/all
// returns 400 for users whose teacher context isn't valid (different brand
// scope, expired role, etc.) — surfacing that as a noisy console error on
// every patient-home visit. Skip the poll entirely under these prefixes.
const SKIP_ROUTE_PREFIXES = ['/patient-home']

export const BookingRequestNavigationAndToastComponent = () => {
  const { profileData, authToken } = useContext(ProfileContext)
  const navigate = useNavigate()
  const location = useLocation()

  const [data, setData] = useState([])

  const onSkippedRoute = SKIP_ROUTE_PREFIXES.some((prefix) =>
    location?.pathname?.startsWith(prefix),
  )

  async function getAllInitiatedBookingRequests() {
    let toReturn = []
    const localToken = localStorage.getItem('token')

    if (isTokenInvalidOrAbsent(authToken) || isTokenInvalidOrAbsent(localToken)) {
      setData([])
      return
    }

    if (profileData && profileData?.authorities?.includes('ROLE_TEACHER')) {
      let response = await getBookingRequestsForMentor(
        dayjs().utc().subtract(24, 'hours').format('YYYY-MM-DDTHH:mm:ss[Z]'),
        true,
      )

      if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
        const initiatedRequests = (response?.data?.data?.bookingRequests || []).filter(
          (item) => item?.status === BOOKING_REQUEST_STATUS.BOOKING_INITIATED,
        )
        toReturn = initiatedRequests
      }
      setData(toReturn)
    }

    return
  }

  function navigateToThePage() {
    if (onSkippedRoute) return
    if (data?.length > 0) {
      toast.success('You have unanswered Booking Requests')
      navigate('/booking-requests-for-mentors/all')
    }
  }

  useEffect(() => {
    if (onSkippedRoute) return
    getAllInitiatedBookingRequests()
  }, [authToken, profileData, onSkippedRoute])

  useEffect(() => {
    navigateToThePage()
  }, [data, onSkippedRoute])

  return <></>
}
export default BookingRequestNavigationAndToastComponent
